export const languages = [
  {
    code: "en",
    name: "English",
  },
  {
    code: "pt",
    name: "Português",
  },
];